import React from 'react';

interface NewOrderIconProps {
  size?: number; // Size of the entire component (circle + icon)
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const NewOrderIcon = ({ 
  size = 40, 
  iconColor = '#14142B',
  backgroundColor = '#F2F4F7',
  strokeWidth = 1.33333 
}: NewOrderIconProps) => {
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M11.5166 6.30205C11.6702 5.99076 11.747 5.83511 11.8513 5.78538C11.9421 5.74211 12.0475 5.74211 12.1383 5.78538C12.2426 5.83511 12.3194 5.99076 12.473 6.30205L13.9308 9.25536C13.9762 9.34726 13.9989 9.39321 14.032 9.42889C14.0614 9.46048 14.0966 9.48607 14.1357 9.50425C14.1798 9.52479 14.2305 9.5322 14.3319 9.54702L17.5928 10.0236C17.9362 10.0738 18.1079 10.0989 18.1873 10.1828C18.2564 10.2558 18.289 10.356 18.2758 10.4557C18.2607 10.5702 18.1364 10.6913 17.8878 10.9334L15.5291 13.2308C15.4556 13.3024 15.4188 13.3382 15.3951 13.3808C15.3741 13.4185 15.3606 13.46 15.3554 13.5028C15.3495 13.5513 15.3582 13.6018 15.3756 13.703L15.9321 16.9479C15.9908 17.2902 16.0201 17.4613 15.965 17.5628C15.917 17.6512 15.8317 17.7132 15.7328 17.7315C15.6192 17.7525 15.4655 17.6717 15.1582 17.5101L12.243 15.9771C12.1522 15.9293 12.1068 15.9054 12.059 15.896C12.0166 15.8877 11.973 15.8877 11.9307 15.896C11.8828 15.9054 11.8374 15.9293 11.7466 15.9771L8.83141 17.5101C8.52407 17.6717 8.3704 17.7525 8.25677 17.7315C8.15791 17.7132 8.07261 17.6512 8.02462 17.5628C7.96946 17.4613 7.99881 17.2902 8.05751 16.9479L8.61405 13.703C8.6314 13.6018 8.64008 13.5513 8.6342 13.5028C8.62901 13.46 8.61553 13.4185 8.59453 13.3808C8.57081 13.3382 8.53404 13.3024 8.46052 13.2308L6.10183 10.9334C5.85323 10.6913 5.72893 10.5702 5.71381 10.4557C5.70065 10.356 5.73316 10.2558 5.80229 10.1828C5.88175 10.0989 6.05344 10.0738 6.39682 10.0236L9.65767 9.54702C9.75907 9.5322 9.80978 9.52479 9.85394 9.50425C9.89303 9.48607 9.92823 9.46048 9.95758 9.42889C9.99073 9.39321 10.0134 9.34726 10.0588 9.25536L11.5166 6.30205Z" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

